module.exports = __webpack_public_path__ + "2edf3624c8e3e80d4f6fed7846b61101.jpg";